import { useEffect } from "react";
import { Box, Flex, Heading, IconButton } from "@chakra-ui/react";
import { X } from "lucide-react";
import type { GetListVideoStreamsEndpointApiResponse } from "@/store";
import { VideoPlayer } from "./VideoPlayer";

type VideoStream = GetListVideoStreamsEndpointApiResponse["streams"][number];

interface VideoModalProps {
  stream: VideoStream;
  onClose: () => void;
}

export function VideoModal({ stream, onClose }: VideoModalProps) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <Box
      position="fixed"
      inset="0"
      zIndex="modal"
      bg="blackAlpha.800"
      onClick={onClose}
    >
      <Flex
        direction="column"
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        bg="gray.900"
        borderRadius="lg"
        overflow="hidden"
        shadow="2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <Flex
          align="center"
          justify="space-between"
          px="4"
          py="3"
          borderBottomWidth="1px"
          borderColor="gray.700"
        >
          <Heading as="h3" size="md" color="white">
            {stream.name}
          </Heading>
          <IconButton
            aria-label="Close"
            variant="ghost"
            size="sm"
            color="white"
            _hover={{ bg: "whiteAlpha.200" }}
            onClick={onClose}
          >
            <X style={{ height: 18, width: 18 }} />
          </IconButton>
        </Flex>

        <VideoPlayer
          playbackUri={stream.playbackUri}
          variant="expanded"
        />
      </Flex>
    </Box>
  );
}
